import { addToDebugData, CycleUtils, ProductUtils } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { StudioOfferingApiClientContext } from '../studio-offering.context';
export const fetchProductQueryFn = async props => {
  var _productCardListData$;
  const {
    httpClient,
    request: {
      productId
    }
  } = props;
  const {
    getProductCardList
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = StudioOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch product');
  }
  const productCardListData = await getProductCardList(p3Context);
  if (!productCardListData || !productCardListData.products) {
    throw new Error('Product card list data is empty');
  }
  const {
    products,
    features,
    recommendedProductFamily
  } = productCardListData;
  addToDebugData({
    products,
    recommendedProductFamily
  });
  const product = products.find(p => p.productId === productId);
  const isRecommended = (recommendedProductFamily == null ? void 0 : recommendedProductFamily.productFamilyId) === (product == null ? void 0 : product.productFamilyId);
  const isEnterprise = ProductUtils.isEnterpriseProduct(product);
  const pricingDetails = product == null ? void 0 : product.pricingDetails;
  const salePerCycle = (pricingDetails == null ? void 0 : pricingDetails.reduce((acc, detail) => {
    var _detail$initialPurcha, _detail$finalPrice;
    const cycle = detail.cycle;
    if (!(cycle != null && cycle.cycleDuration)) {
      return acc;
    }
    const cycleId = CycleUtils.convertCycleToCycleId(cycle);
    const initialPrice = (_detail$initialPurcha = detail.initialPurchasePrice) == null || (_detail$initialPurcha = _detail$initialPurcha.total) == null ? void 0 : _detail$initialPurcha.amount;
    const finalAmount = (_detail$finalPrice = detail.finalPrice) == null || (_detail$finalPrice = _detail$finalPrice.total) == null ? void 0 : _detail$finalPrice.amount;
    const hasSale = initialPrice != null && finalAmount != null && initialPrice !== finalAmount;
    acc[cycleId] = hasSale;
    return acc;
  }, {})) ?? undefined;
  const hasSale = salePerCycle != null && Object.values(salePerCycle).some(Boolean);
  return {
    name: (product == null ? void 0 : product.name) ?? '',
    description: (product == null ? void 0 : product.description) ?? '',
    features: features.getByProductId(productId),
    isRecommended,
    isEnterprise,
    recommendedDisplayText: productCardListData == null || (_productCardListData$ = productCardListData.recommendedProductFamily) == null || (_productCardListData$ = _productCardListData$.displayInfo) == null ? void 0 : _productCardListData$.displayText,
    pricingDetails,
    salePerCycle: salePerCycle,
    hasSale
  };
};
//# sourceMappingURL=fetch-product.query.js.map